import { render, staticRenderFns } from "./SCardPurchaseComp.vue?vue&type=template&id=53a0028b&"
import script from "./SCardPurchaseComp.vue?vue&type=script&lang=js&"
export * from "./SCardPurchaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports